<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 系统设置 / 充值银行卡 / 编辑银行卡</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>银行卡类型
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="bankType" class="boxText">
                <option>银行卡</option>
                <option>支付宝扫码</option>
              </select>
            </td>
          </tr>
          <tr :style="[{display:bankType=='银行卡'?'':'none'}]">
            <td class="leftTd">
              <span style="color: red">* </span>银行名称
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="name" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>支行名称/支付宝开户人姓名
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="childName" class="boxText"/>
            </td>
          </tr>
          <tr :style="[{display:bankType=='银行卡'?'':'none'}]">
            <td class="leftTd">
              <span style="color: red">* </span>卡号
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="card" class="boxText"/>
            </td>
          </tr>
          <tr :style="[{display:bankType=='银行卡'?'none':''}]">
            <td class="leftTd">
              支付宝二维码
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <img :src="showImg" style="width: 100px;cursor:pointer;" onclick="f1.click()" />
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>开户人/支付宝账户
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="userName" class="boxText"/>
            </td>
          </tr>

        </table>
      </div>

      <div style="padding-top: 15px; padding-left: 150px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="保存" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, FILE_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "UddSystemConfig",
  data(){
    return{
      bankType:"银行卡",
      id:0,
      name:"",
      card:"",
      childName:"",
      userName:"",
      imgUrl:"",
      showImg:"",
    }
  },
  mounted(){
    this.imgUrl=FILE_URL
    this.showImg=require('@/assets/fileImg.png')
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    let json=JSON.parse(localStorage.getItem("UPDATEOBJ"))
    console.log(json)
    this.id=json.bankId
    this.name=json.bankName
    this.card=json.bankCard
    this.childName=json.bankChildName
    this.userName=json.bankUserName
    this.userName=json.bankUserName
    this.showImg=this.imgUrl+json.bankCard
    if(json.bankName=="支付宝"){
      this.bankType="支付宝扫码"
    }

  },
  methods: {
    addAdmin(){
      let that=this
      if(this.bankType=="银行卡"){
        if(this.name==""){
          toask("请输入银行名称！",6)
          return
        }
        if(this.card==""){
          toask("请输入卡号！",6)
          return
        }
        if(this.childName==""){
          toask("请输入支行名称！",6)
          return
        }
        if(this.userName==""){
          toask("请输入开户人！",6)
          return
        }
      }else{
        this.name="支付宝"
        if(this.card==""){
          toask("请上传收款二维码！",6)
          return
        }
        if(this.childName==""){
          toask("请输入支付宝开户人姓名！",6)
          return
        }
        if(this.userName==""){
          toask("请输入支付宝账户！",6)
          return
        }
      }
      loading("请求中")
      axiosPost(DO_NET_URL+"api/EditBank?id="+this.id+"&name="+this.name+"&card="+this.card+"&childName="+this.childName+"&userName="+this.userName,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("保存成功",6)
          setTimeout(function (){
            that.$emit("send",'systemBank')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback(){
      this.$emit("send",'systemBank')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>